import { call, put, take } from 'redux-saga/effects';

import { GO_TO_PREVIOUS_PAGE } from './actions';
import { notifications, SET_ISLOADING } from 'PipeRouter';

import { goToPreviousPage as goPrevPage } from 'Services/learnkit';


function* goToPreviousPage() {
  while (true) {
    yield take(GO_TO_PREVIOUS_PAGE);

    yield put(notifications(SET_ISLOADING, true));
    yield call(goPrevPage);
  }
}


export default goToPreviousPage;
